import React, { Component } from "react";

import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import Icon from "@mui/material/Icon";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";

// Data
import reportsBarChartData from "layouts/dashboard/data/reportsBarChartData";
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";

// Dashboard components
import Projects from "layouts/dashboard/components/Projects";
import OrdersOverview from "layouts/dashboard/components/OrdersOverview";
import GradientLineChart from "examples/Charts/LineCharts/GradientLineChart";

import { GareCalendar } from "components/GareCalendar"
import { CommesseCalendar } from "components/CommesseCalendar"
import { CommessaMaps } from "components/CommessaMaps"
import { CommesseAndamento } from "components/CommesseAndamento"

import { getAllMonthsinYear, calculateBudgetReal, calculateMarkupReal, getLastDateOfMonthBefore, getLastDateOfMonth, getAllMonths, toPrice, convertDate, getBusinessDatesCount, calculateMarkup, getWorkedDaysNumber, materialCostCommessa, laborCostCommessa, calculateSAL } from "helpers/functions"


import * as ajax from "helpers/ajax";
import { PATH, UPLOAD_PATH, GOOGLE_API_KEY, FATTURE_PATH, FATTURE_API_KEY, UFFICIO_ID } from "../../constant";

export default class Dashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            graphSelected: "TOTAL",
            commesse: [],
            workerLoaded: 0,
            selectedYear: new Date().getFullYear(),

        };
        this.graphData()
    }

    componentDidMount = () => {
        ajax.ajaxGetStrapi("commessas?populate=*&filters[commessa_madre]&filters[stato][$ne]=finito&sort[0]=nome&populate=fattures&populate=commessa_madre&populate=incarichi.*&populate=incarichi.commessa_madre&populate=incarichi.fattures", this.loadCallback)
    }

    loadCallback = (response) => {
        let temp = response.data
        temp.forEach((element) => element.workers=[]);
        this.setState({ commesse: temp }, this.loadWorkers)
    }

    loadWorkers = () => {
        let temp = this.state.commesse
        temp.forEach((el) => {
            let filter = "&filters[commessa][id]=" + el.id;
            if (el.incarichi.length > 0) {
                filter = "";
                el.incarichi.map((x, i) => {
                    filter += "&filters[commessa][id][$in][" + i + "]=" + x.id;
                })
            }

            fetch(PATH + "operai-commesses?populate=operaio" + filter, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${global.jwt}`,
                },
            })
                .then((response) => response.json())
                .then((responseJson) => {
                    el.workers = responseJson.data;
                    this.setState({ workerLoaded: this.state.workerLoaded + 1 })
                })
        })
    }
    

    graphData = () => {
        //console.log(global)
        var d = new Date();
        d.setMonth(d.getMonth() - 5);

        let labels = getAllMonthsinYear(this.state.selectedYear + "-01-01")
        let dates = getAllMonthsinYear(this.state.selectedYear + "-01-01", "date")

        let datasets = [];

        let colors = ["primary", "secondary", "info", "success", "warning", "error", "light", "dark"];

        this.state.commesse.map((commessa, index) => {
            if (commessa.id == UFFICIO_ID) { return }

            let tempC = {
                label: commessa.nome,
                color: colors[index%colors.length],
                data:[],
            }

            if (commessa.incarichi.length > 0) {
                commessa.fc_ordini = [];
                commessa.incarichi.map((incarico, index) => {
                    
                    commessa.fattures = []
                    incarico.fattures.map((fatt) => {
                        commessa.fattures.push(fatt)
                    })

                    commessa.fc_ordini = commessa.fc_ordini.concat(incarico.fc_ordini);
                })

            }




            if (this.state.graphSelected == "TOTAL") {
                let materialCost = [];
                let workerCost = [];
                let totalCost = [];

                dates.forEach((el) => {
                    let temp = materialCostCommessa(commessa, el, getLastDateOfMonth(el));
                    if (materialCost.length > 0) {
                        temp += materialCost[materialCost.length - 1];
                    } else {
                        temp += materialCostCommessa(commessa, "1900-01-01", getLastDateOfMonthBefore(el));
                    }


                    let tempWork = laborCostCommessa(commessa.workers, el, getLastDateOfMonth(el), commessa);
                    if (workerCost.length > 0) {
                        tempWork += workerCost[workerCost.length - 1];
                    } else {
                        tempWork += laborCostCommessa(commessa.workers, "1900-01-01", getLastDateOfMonthBefore(el), commessa);
                    }
                    if (!tempWork) { tempWork = 0 }

                    materialCost.push(temp);
                    workerCost.push(tempWork);
                    totalCost.push(materialCost[materialCost.length - 1] + workerCost[workerCost.length - 1])
                    tempC.data = totalCost;
                });
            }

            if (this.state.graphSelected == "MARKUP") {
                let materialCost = [];
                let workerCost = [];

                dates.forEach((el) => {
                    let temp = materialCostCommessa(commessa, el, getLastDateOfMonth(el));
                    if (materialCost.length > 0) {
                        temp += materialCost[materialCost.length - 1];
                    } else {
                        temp += materialCostCommessa(commessa, "1900-01-01", getLastDateOfMonthBefore(el));
                    }

                    let tempWork = laborCostCommessa(commessa.workers, el, getLastDateOfMonth(el), commessa);
                    if (workerCost.length > 0) {
                        tempWork += workerCost[workerCost.length - 1];
                    } else {
                        tempWork += laborCostCommessa(commessa.workers, "1900-01-01", getLastDateOfMonthBefore(el), commessa);
                    }

                    materialCost.push(temp);
                    workerCost.push(tempWork);
                });


                let markup = [];
                dates.forEach((el, index) => {
                    let temp = calculateMarkupReal(commessa, materialCost[index], workerCost[index], el, getLastDateOfMonth(el))
                    if (temp.length > 0) {
                        temp += temp[temp.length - 1];
                    } else {
                        temp += calculateMarkupReal(commessa, 0, 0, "1900-01-01", getLastDateOfMonthBefore(el))
                    }

                    markup.push(temp);

                });
                tempC.data = markup;
            }


            if (this.state.graphSelected == "ORDER") {
                let materialCost = [];

                dates.forEach((el) => {
                    let temp = materialCostCommessa(commessa, el, getLastDateOfMonth(el));
                    if (materialCost.length > 0) {
                        temp += materialCost[materialCost.length - 1];
                    } else {
                        temp += materialCostCommessa(commessa, "1900-01-01", getLastDateOfMonthBefore(el));
                    }

                    materialCost.push(temp);
                    tempC.data = materialCost;
                });
            }


            if (this.state.graphSelected == "WORKER") {
                let workerCost = [];

                dates.forEach((el) => {
                    let tempWork = laborCostCommessa(commessa.workers, el, getLastDateOfMonth(el), commessa);
                    if (workerCost.length > 0) {
                        tempWork += workerCost[workerCost.length - 1];
                    } else {
                        tempWork += laborCostCommessa(commessa.workers, "1900-01-01", getLastDateOfMonthBefore(el), commessa);
                    }
                    if (!tempWork) { tempWork = 0 }

                    workerCost.push(tempWork);
                    tempC.data = workerCost;
                });
            }

            datasets.push(tempC);


        })

        return {
            labels: labels,
            datasets: datasets
        }
    }

    graphIcon = () => {
        if (this.state.graphSelected == "TOTAL") { return "attach_money" }
        if (this.state.graphSelected == "MARKUP") { return "trending_up" }
        if (this.state.graphSelected == "ORDER") { return "shopping_cart" }
        if (this.state.graphSelected == "WORKER") { return "engineering" }

        return "attach_money"
    }

    changeYear = (n) => {
        let date = this.state.selectedYear
        date += n;
        this.setState({ selectedYear: date })
    }

    render = () => {
        return (
            <DashboardLayout>
                <DashboardNavbar />

                <Grid container>
                    <Grid item md={6}>
                        <MDBox sx={{ backgroundColor: "white!important", flex: 1 }} p={3} m={1} borderRadius="lg" shadow="lg" >
                            <GareCalendar />
                        </MDBox>
                    </Grid>

                    <Grid item md={6}>
                        <MDBox sx={{ backgroundColor: "white!important", flex: 1 }} p={3} m={1} borderRadius="lg" shadow="lg" >
                            <CommesseCalendar />
                        </MDBox>
                    </Grid>

                    <Grid item md={6}>
                        <MDBox sx={{ backgroundColor: "white!important", flex: 1 }} p={3} m={1} borderRadius="lg" shadow="lg" >
                            <CommessaMaps />
                        </MDBox>
                    </Grid>

                    <Grid item md={6}>
                        <MDBox sx={{ backgroundColor: "white!important", flex: 1 }} p={0} m={1} borderRadius="lg" >
                            <MDBox display="flex">
                                <MDBox width="4rem"
                                    height="4rem"
                                    bgColor={"info"}
                                    variant="gradient"
                                    coloredShadow={"info"}
                                    borderRadius="xl"
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    color="white"
                                    mr={2}
                                    ml={2}>
                                    <Icon>{this.graphIcon()}</Icon>
                                </MDBox>    
                                <MDBox alignItems="center">
                                    <MDTypography variant="h6">ANDAMENTO COMMESSE</MDTypography>
                                </MDBox>
                            </MDBox>

                            <Grid container>
                                <Grid item p={1}>
                                    <MDBox display="flex" flexDirection="column" alignItems="center">
                                        <MDTypography variant="caption">Costi Totali ad oggi</MDTypography>
                                        <MDButton onClick={() => this.setState({graphSelected:"TOTAL"})} variant="gradient" color={(this.state.graphSelected == "TOTAL") ? "info" :"secondary"} iconOnly><Icon>attach_money</Icon></MDButton>
                                    </MDBox>
                                </Grid>
                                <Grid item p={1}>
                                    <MDBox display="flex" flexDirection="column" alignItems="center">
                                        <MDTypography variant="caption">Mark up reale</MDTypography>
                                        <MDButton onClick={() => this.setState({ graphSelected: "MARKUP" })} variant="gradient" color={(this.state.graphSelected == "MARKUP") ? "info" : "secondary"} iconOnly><Icon>trending_up</Icon></MDButton>
                                    </MDBox>
                                </Grid>
                                <Grid item p={1}>
                                    <MDBox display="flex" flexDirection="column" alignItems="center">
                                        <MDTypography variant="caption">Costo Ordini ad oggi</MDTypography>
                                        <MDButton onClick={() => this.setState({ graphSelected: "ORDER" })} variant="gradient" color={(this.state.graphSelected == "ORDER") ? "info" : "secondary"} iconOnly><Icon>shopping_cart</Icon></MDButton>
                                    </MDBox>
                                </Grid>
                                <Grid item p={1}>
                                    <MDBox display="flex" flexDirection="column" alignItems="center">
                                        <MDTypography variant="caption">Costo Manodopera ad oggi</MDTypography>
                                        <MDButton onClick={() => this.setState({ graphSelected: "WORKER" })} variant="gradient" color={(this.state.graphSelected == "WORKER") ? "info" : "secondary"} iconOnly><Icon>engineering</Icon></MDButton>
                                    </MDBox>
                                </Grid>
                            </Grid>   
                            
                            <GradientLineChart
                                chart={this.graphData()}
                                priceMode={true}
                            />
                            <Grid mb={3} container justifyContent={"space-around"}>
                                <Grid item>
                                    <MDButton variant="text" color="dark" onClick={() => this.changeYear(-1)}><Icon>keyboard_double_arrow_left</Icon></MDButton>
                                </Grid>
                                <Grid item>{this.state.selectedYear}</Grid>
                                <Grid item>
                                    <MDButton variant="text" color="dark" onClick={() => this.changeYear(1)}><Icon>keyboard_double_arrow_right</Icon></MDButton>
                                </Grid>
                            </Grid>

                        </MDBox>
                    </Grid>


                    <Grid item sm={12}>
                        <MDBox sx={{ backgroundColor: "white!important", flex: 1, height:550 }} p={3} m={1} borderRadius="lg" shadow="lg" >
                            <CommesseAndamento />
                        </MDBox>
                    </Grid>


                </Grid>

            </DashboardLayout>

        )
    }
}